<template>
  <div id="app" class="ASDFADFdark-mode" :class="{'overflow-x-hidden': this.resultPage.isMobile}">
    <delete-job-modal></delete-job-modal>
    <share-modal></share-modal>
    <share-qr-code-modal></share-qr-code-modal>
    <cancel-task-modal></cancel-task-modal>

    <BaseLayout v-if="resultPage.isMobile === false">
      <template v-slot:topbar>
        <router-view name="Topbar"></router-view>
      </template>
      <template v-slot:sidebar-left>
        <router-view name="SidebarLeft"></router-view>
      </template>
      <template v-slot:main-canvas-ad>
        <div class="d-flex justify-content-center banner-ad-size" v-if="!isPremiumUser">
          <div :id="adId"></div>
        </div>
      </template>
      <template v-slot:secondary-nav>
        <div class="secondary-nav">
          <router-view name="SecondaryNav"></router-view>
        </div>
      </template>
      <template v-slot:main-canvas>
        <router-view></router-view>
      </template>
      <template v-slot:sidebar-right>
        <router-view name="SidebarRight"></router-view>
      </template>
    </BaseLayout>

    <MobileLayout v-if="resultPage.isMobile === true">
      <template v-slot:main-canvas>
        <router-view name="MobileDefault"></router-view>
      </template>
      <template v-slot:mobile-secondary-navbar>
        <router-view name="MobileSecondaryNavbar"></router-view>
      </template>
      <template v-slot:mobile-navbar>
        <router-view name="MobileNavbar"></router-view>
      </template>
    </MobileLayout>
  </div>
</template>
<script>
import store from './mixins/store.mixin'
import JobManager from "./manager/JobManager";
import BaseLayout from "./layout/BaseLayout.vue";
import {EventBus} from "./events/event.bus";
import {EVENT_APP_NAVIGATE} from "./events/app.events";
import ResultPageManager from "./manager/ResultPageManager";
import MobileLayout from "./layout/MobileLayout.vue";
import CreditLimitModal from "./components/Modal/CreditLimitModal.vue";
import UnlockProModal from "./components/Modal/UnlockProModal.vue";
import MaxConcurrentLimitModal from "./components/Modal/MaxConcurrentLimitModal.vue";
import GenericErrorModal from "./components/Modal/Error/GenericErrorModal.vue";
import JobFailedModal from "./components/Modal/Error/JobFailedModal.vue";
import DeleteJobModal from "./components/Modal/DeleteJobModal.vue";
import CancelTaskModal from "./components/Modal/CancelTaskModal.vue";
import ShareModal from "./components/Modal/ShareModal.vue";
import ShareQrCodeModal from "./components/Modal/ShareQrCodeModal.vue";
import user from "./mixins/user.mixin";
import {satGlobals} from "../../../../sat/helper/sat-globals";

function waitForElement(elementId, callBack) {
  window.setTimeout(function () {
    var element = document.getElementById(elementId);
    if (element) {
      callBack(elementId, element);
    } else {
      waitForElement(elementId, callBack);
    }
  }, 250)
}

function isMobileAdSite() {
  if (navigator.connection && navigator.connection.effectiveType) {
    if (navigator.connection.effectiveType === '4g') {
      satConnectionType = 'fast';
      return false;
    } else {
      satConnectionType = 'slow';
      return true;
    }
  }
  return false;
}

function getCookieValue(name) {
  try {
    name = name.toLowerCase();
    var rawCookieString = document.cookie;

    var parts = rawCookieString.split(';');

    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].split('=');

      if (p.length === 2) {
        var key = p[0].trim().toLowerCase();
        var value = p[1].trim();

        if (key === name) {
          return value;
        }
      }
    }
  } catch (e) {

  }

  return null;
}

export default {
  name: "ResultV2",
  components: {
    ShareModal,
    ShareQrCodeModal,
    DeleteJobModal,
    JobFailedModal,
    GenericErrorModal,
    MaxConcurrentLimitModal,
    CreditLimitModal,
    UnlockProModal,
    BaseLayout,
    MobileLayout,
    CancelTaskModal,
  },
  mixins: [
    store,
    user
  ],
  data() {
    return {
      event_app_navigate: EVENT_APP_NAVIGATE,
      listener: false,
      adId: satGlobals.getProjectName().toLowerCase() + '_post_1'
    };
  },
  created: function () {
    if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
      this.adId = 'td-top-leaderboard-1';
    }
    if (satGlobals.getProjectName().toLowerCase() === 'online-convert') {
      this.adId = 'post_conversion_728x90';
    }
    let jobId = JobManager.create()

    if (this.listener === false) {
      JobManager.listen();
      ResultPageManager.watchMobile();
      this.navigationListener();
      this.listener = true;
    }

    ResultPageManager.updateMobile();
    ResultPageManager.listen();
    ResultPageManager.initJob(jobId);
  },
  mounted: function () {
    if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
      this.loadImg2GoAds();
    }
  },
  methods: {
    loadImg2GoAds() {
      if (getCookieValue('qgrole') !== 'premium' && isMobileAdSite() === false && sessionStorage.getItem('PLAYWRIGHT') !== 'true') {
        waitForElement('td-top-leaderboard-1', () => {
          waitForElement('td-top-mpu-1', () => {
            var script = document.createElement("script");
            script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
            script.setAttribute('async', true);
            document.body.appendChild(script);

            var script = document.createElement("script");
            script.src = "https://spn-v1.revampcdn.com/prebid/img2go/prebid-client.js";
            script.setAttribute('async', true);
            document.head.appendChild(script);

            var script = document.createElement("script");
            script.src = "https://spn-v1.revampcdn.com/publishers/img2go.js?modern=1";
            script.setAttribute('async', true);
            script.setAttribute('type', 'module');
            document.head.appendChild(script);

            var script = document.createElement("script");
            script.src = "https://spn-v1.revampcdn.com/publishers/img2go.js";
            script.setAttribute('nomodule', true);
            document.head.appendChild(script);

            !function (t) {
              function s(s, a) {
                t.revamp.cmd.push([s, a])
              }

              t.revamp = t.revamp || {}, t.revamp.cmd = [], t.revamp.displaySlots = t.revamp.displaySlots || function () {
                s("displayDeferredSlots", arguments)
              }, t.revamp.destroySlots = t.revamp.destroySlots || function () {
                s("destroyGptSlots", arguments)
              }, t.revamp.displayCustomInterstitial = t.revamp.displayCustomInterstitial || function () {
                s("displayCustomInterstitial", arguments)
              }
            }(window);
          })
        })
      }
    },
    navigationListener() {
      EventBus.$on(this.event_app_navigate, (route, params, query = {}, replace = false) => {
        if (replace === true) {
          query.rand = Math.floor(Math.random() * 100);
          this.$router.replace({path: route, params: params, query: query});
        } else {
          query.rand = Math.floor(Math.random() * 100);
          this.$router.push({path: route, params: params, query: query});
        }
      })
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.banner-ad-size {
  min-height: 90px;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

#app {
  background: #F5F5F5;


  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-button {
    width: 8px;
    height: 0;
  }

  ::-webkit-scrollbar-track {
    background: #eee;
    border: thin solid lightgray;
    //box-shadow: 0px 0px 3px #dfdfdf inset;
    border-radius: 0;
    border-top: 0;
    border-bottom: 0;
  }

  ::-webkit-scrollbar-thumb {
    background: #a8a8a8;
    border: thin solid #999;
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #7d7d7d;
  }
}
</style>
